<template>
  <div v-dragWhole class="set-camera" v-show="isShow" :style="setCameraStyle">
    <!-- 镜头对象 -->
    <div class="camera" :class="{active: i===lensIndex}" v-for="(c, i) in lensPart" :style="{
      left: c.matrix.x + 'px',
      top: c.matrix.y + 'px',
      width: c.matrix.w + 'px',
      height: c.matrix.h + 'px',
      }">
      <div class="camera-name">{{i===0?'默认镜头':'镜头'+i}}</div>
      <div class="camera-help" :class="{active: i===lensIndex}" :data-action="'move-' + i">
        <div :class="'op-handle-point op-handle-' + point.action" v-for="point in points" :data-id="c.id" :data-action="point.action +'-'+i" :style="point.pt"></div>
      </div>
    </div>
    <!-- 辅助线 -->
    <div class="camera_auxiliary">
      <div v-show="n.show" v-for="n in netLine" :style="{top: n.top + 'px', left: n.left + 'px'}"></div>
    </div>

    <div class="camera-icon">
      <div class="c-l-t"></div>
      <div class="c-r-t"></div>
      <div class="c-r-b"></div>
      <div class="c-l-b"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dragFn from '@/components/mixins/forDragFn';

export default {
  name: 'setCamera',
  mixins: [dragFn],
  data() {
    return {
      ANALYSIS: {
        move : {category:'camera_track', action:'drag_canvas_camera', label:'镜头特效_移动画布镜头'},
        scale : {category:'camera_track', action:'drag_canvas_camera_lens', label:'镜头特效_放缩画布镜头'},
      },
      isShow: false,
      lensPart: [], // 所有镜头对象
      dragHandle: false, // 是否拖动中
      points: [ // 操作点
        { pt: {left: '-6px', bottom: '-6px'}, action: 'sw' },
        { pt: {left: '-6px', top: '-6px'}, action: 'nw' },
        { pt: {right: '-6px', top: '-6px'}, action: 'ne' },
        { pt: {right: '-6px', bottom: '-6px', left: 'auto', top: 'auto'}, action: 'se' },
      ],
      mpos: null, // mousedown的保留属性集合
      action: '', // 拖动动作
      adsorbArr: [], // 吸附所要对其的数据 分奇偶
      adsorbData: [], // 正在吸附中的数据
      netLine: [], // 吸附线的属性
    }
  },
  computed: {
    ...mapGetters([
      "SelectSprites_Msg",
      "SelectScenes_Msg",
      "TOOL",
      "lensEditState",
      "lensIndex",
      "cameras"
    ]),
    setCameraStyle() {
      const style = {};
      style.width = this.TOOL.clientWidth + 'px';
      style.height = this.TOOL.clientHeight + 'px';
      style.top = this.TOOL.fixTop + 'px';
      style.left = this.TOOL.fixLeft + 'px';
      return style;
    },
    cameraStyle(m) {
      const style = {};
      style.width = m.w + 'px';
      style.height = m.h + 'px';
      style.top = m.y + 'px';
      style.left = m.x + 'px';
      return style;
    }
  },
  watch: {
    lensEditState(val, oldVal) {
      if(val) {
        if(this.isShow) return;
        this.init()
      } else {
        this.isShow = false;
      }
    },
    cameras() {
      this.isShow && this.init()
    },
    SelectSprites_Msg(val, oldVal) {
      if(this.isShow && val.length > 0) {
        this.close()
      }
    },
    'TOOL.clientWidth' (val, oldVal) {
      this.isShow && this.init()
    },
    'TOOL.clientHeight' (val, oldVal) {
      this.isShow && this.init()
    },
    'TOOL.optimized'(val, oldVal) {
      this.isShow && this.init()
    }
  },
  mounted () {
    for (let i = 0; i<6; i++) {
      this.netLine = this.netLine.concat({show: false,top:0,left: 0})
    }
    this.$bus.on('undoRedoHandle', (data) => {
      // 撤销和恢复的事件
      if(data.type === 'camera_matrix' || data.type === 'editor_resize') {
        setTimeout(() => {
          if(!this.isShow) {
            this.$store.commit('toggle_lensEditState', true);
          } else {
            this.init()
          }
        })
      }
    })
    this.$bus.on('keycode_move', data => {
      if(data.shortcutType === 'camera' && this.lensIndex > -1) {
        let m = this.lensPart[this.lensIndex].matrix;
        let undoData = {
          scenesId: this.SelectScenes_Msg.id,
          cameraIndex: this.lensIndex,
          reData: this.toHorizontal(m),
          scale: this.TOOL.scale
        }
        let mF = {
              w: this.TOOL.clientWidth,
              h: this.TOOL.clientHeight,
              x: 0,
              y: 0
            };
        if(this.TOOL.optimized === 'Vertical') {
          mF.w = mF.h * 9 / 16;
          mF.x = mF.h * 175 / 288;
        }
        let range = [
              mF.w - m.w + mF.x,
              mF.h - m.h,
            ];

        let pos = {
          left: m.x + data.x,
          top: m.y + data.y
        }

        if(pos.left < mF.x) {
          pos.left = mF.x;
        }else if(pos.left > range[0]) {
          pos.left = range[0];
        }
        if(pos.top < 0) {
          pos.top = 0;
        }else if(pos.top > range[1]) {
          pos.top = range[1];
        }
        m.x = pos.left;
        m.y = pos.top;

        this.SelectScenes_Msg.camera.updateCamera(this.lensIndex, {matrix: this.toHorizontal(m)})
        undoData.data = this.toHorizontal(m)
        eve("undo_redo", null, {type: 'camera_matrix', data: undoData})
      }
    })
  },
  methods: {
    init() {
      // 初始化镜头数据(以及竖版镜头的数据处理)
      this.isShow = true;
      this.lensPart = $.extend(true, [], this.cameras)
      this.$store.commit('toggle_cameras', this.SelectScenes_Msg.camera.cameras);
      if(this.TOOL.optimized === 'Vertical') {
        this.toVertical()
      }
    },
    dragDown(dis, action) {
      this.dragHandle = false
      if(!action) return;
      let actionS = action.split('-');
      let m = null;
      this.$store.commit('toggle_lensIndex', + actionS[1]);
      this.action = actionS[0];
      m = this.lensPart[this.lensIndex].matrix;
      this.mpos = {
        x: dis.x - this.TOOL.PfixLeft,
        y: dis.y - this.TOOL.PfixTop,
        w: m.w,
        h: m.h,
        t: m.y,
        l: m.x,
        cx: m.x + m.w/2,
        cy: m.y + m.h/2,
        minScale: this.TOOL.clientHeight/15/m.h,
        undoData: {
          scenesId: this.SelectScenes_Msg.id,
          cameraIndex: this.lensIndex,
          reData: this.toHorizontal(m)
        }
      };
      // 限制的获取
      let max1 = 0,
          max2 = 0,
          mF = {
            w: this.TOOL.clientWidth,
            h: this.TOOL.clientHeight,
            x: 0,
            y: 0
          };
      if(this.TOOL.optimized === 'Vertical') {
        mF.w = mF.h * 9 / 16;
        mF.x = mF.h * 175 / 288;
      }
      switch(this.action) {
        case 'sw':
          //左下
          max1 = (m.x + m.w - mF.x) / m.w;
          max2 = (mF.h - m.y) / m.h;
          break;
        case 'nw':
          // 左上
          max1 = (m.x + m.w - mF.x) / m.w;
          max2 = (m.y + m.h) / m.h;
          break;
        case 'ne':
          // 右上
          max1 = (mF.w - m.x + mF.x) / m.w;
          max2 = (m.y + m.h) / m.h;
          break;
        case 'se':
          // 右下
          max1 = (mF.w - m.x + mF.x) / m.w;
          max2 = (mF.h - m.y) / m.h;
          break;
        case 'move':
          this.mpos.range = [
            mF.w - m.w + mF.x,
            mF.h - m.h,
            mF.x
          ];
          this.TOOL.adsorb && this._getAdsorbArr()
          break;
      }
      this.mpos.maxScale = Math.min(max1, max2);
    },
    dragMove(pos) {
      this.dragHandle = true;
      if(!this.action) return;
      let position = {},
          size = {},
          scaleSize = 0,
          info = {},
          nowArr = null,
          num = 0,
          mx = this.lensPart[this.lensIndex].matrix;
      pos.x-=this.TOOL.PfixLeft;
      pos.y-=this.TOOL.PfixTop;
      if(this.action === 'move') {
        position.left = this.mpos.l + pos.x - this.mpos.x;
        position.top = this.mpos.t + pos.y - this.mpos.y;

        if(position.left < this.mpos.range[2]) {
          position.left = this.mpos.range[2];
        }else if(position.left > this.mpos.range[0]) {
          position.left = this.mpos.range[0]
        }
        if(position.top < 0) {
          position.top = 0;
        }else if(position.top > this.mpos.range[1]) {
          position.top = this.mpos.range[1]
        }

        mx.x = position.left;
        mx.y = position.top;
        if(this.TOOL.adsorb) {
          info = this._getAdsorbPos('move', 0, mx, this.mpos);
          if(typeof info.x === 'number') position.left = info.x;
          if(typeof info.y === 'number') position.top = info.y;

          if(position.left < 0) {
            position.left = 0;
          }else if(position.left > this.mpos.range[0]) {
            position.left = this.mpos.range[0];
          }
          if(position.top < 0) {
            position.top = 0;
          }else if(position.top > this.mpos.range[1]) {
            position.top = this.mpos.range[1];
          }

          mx.x = position.left;
          mx.y = position.top;
        }
      } else {
        let dir = '';
        scaleSize = Math.abs(this._scaleSize(pos.x, pos.y, this.mpos.x, this.mpos.y, this.mpos.cx, this.mpos.cy));
        if(scaleSize <= this.mpos.minScale) {
          scaleSize = this.mpos.minScale;
        }else if(scaleSize >= this.mpos.maxScale){
          scaleSize = this.mpos.maxScale;
        }
        size.w = this.mpos.w * scaleSize;
        size.h = this.mpos.h * scaleSize;
        switch(this.action) {
          case 'sw':
            dir = 'top-right';
            num = 2;
            break;
          case 'nw':
            dir = 'bottom-right';
            num = 3;
            break;
          case 'ne':
            dir = 'bottom-left';
            num = 0;
            break;
          case 'se':
            dir = 'top-left';
            num = 1;
            break;
        }
        position = this._rotSize(size.w, size.h, this.mpos.w, this.mpos.h, this.mpos.l, this.mpos.t, 0, dir);
        mx.w = size.w;
        mx.h = size.h;
        mx.x = position.left;
        mx.y = position.top;
        if(this.TOOL.adsorb) {
          info = this._getAdsorbPos('ratio', num, mx, this.mpos);
          if(typeof info.s === 'number') {
            info.s = Math.abs(info.s);
            if(info.s <= this.mpos.minScale) {
              info.s = this.mpos.minScale;
            }else if(info.s >= this.mpos.maxScale){
              info.s = this.mpos.maxScale;
            }
            size.w = this.mpos.w * info.s;
            size.h = this.mpos.h * info.s;
            position = this._rotSize(size.w, size.h, this.mpos.w, this.mpos.h, this.mpos.l, this.mpos.t, 0, dir);
            mx.w = size.w;
            mx.h = size.h;
            mx.x = position.left;
            mx.y = position.top;
          }
        }
      }
    },
    dragUp() {
      if(!this.action) return;
      this.$analysis(this.ANALYSIS[this.action] || this.ANALYSIS.scale)
      this.action = '';

      if(this.TOOL.adsorb) {
        this.netLine.forEach( k => {
          k.show = false;
        })
      }

      if(!this.dragHandle) {
        this.mpos = null;
        return;
      }
      this.dragHandle = false;
      this.SelectScenes_Msg.camera.updateCamera(this.lensIndex, {matrix: this.toHorizontal(this.lensPart[this.lensIndex].matrix)})
      this.mpos.undoData.data = this.toHorizontal(this.lensPart[this.lensIndex].matrix)
      this.mpos.undoData.scale = this.TOOL.scale;
      eve("undo_redo", null, {type: 'camera_matrix', data: this.mpos.undoData})
      this.mpos = null;
    },
    close() {
      // 关闭
      this.$store.commit('toggle_lensEditState', false);
      this.isShow = false;
    },
    _getAdsorbData(info) {
      // 获取外接矩形的信息(没有旋转)
      var c = {
          x: info.x + info.w / 2,
          y: info.y + info.h / 2
      };
      // 分别是top, right, bottom, left, centerY, chenterX
      return [info.y, info.x+info.w, info.y+info.h, info.x, c.y, c.x];
    },
    _getAdsorbPos(action, start, info, mpos) {
      let adsorb = this._getAdsorbData(info),
          arr = [
            [],
            []
          ],
          data = [{}, {}, {}, {}, {}, {}],
          need = [],
          b = {
            t: mpos.t,
            r: mpos.l + mpos.w,
            b: mpos.t + mpos.h,
            l: mpos.l,
            w: mpos.w,
            h: mpos.h
          },
          re = {};
      
      for(let i in this.adsorbArr) {
        arr[i%2].push(this.adsorbArr[i])
      }

      need[0] = start;
      need[1] = (start + 1) % 4;

      for(let j in adsorb) {
        if(action === 'ratio' && j != need[0] && j != need[1]) continue;
        let index = j % 2;
        for(let k in arr[index]) {
          if(Math.abs(adsorb[j] - arr[index][k]) <= 5) {
            data[j].k = adsorb[j];
            data[j].v = arr[index][k];
            data[j].arr = adsorb;
          }
        }
      }
      this.showNetLine(data)
      if(action === 'move') {
        data.forEach((v, i) => {
          if(v.v) {
            if(i % 2 === 0) {
              re.y = v.v - v.arr[i] + v.arr[4] - b.h / 2;
            } else {
              re.x = v.v - v.arr[i] + v.arr[5] - b.w / 2;
            }
          }
        })
      } else {
        data.forEach((v, i) => {
          if(v.v) {
            if(i === 0) re.s = (v.v - b.b) / b.h;
            if(i === 1) re.s = (v.v - b.l) / b.w;
            if(i === 2) re.s = (v.v - b.t) / b.h;
            if(i === 3) re.s = (v.v - b.r) / b.w;
          }
        })
      }
      return re;
    },
    _getAdsorbArr() {
      // 获取要吸附的数据(包括元素)
      this.adsorbArr = this.SelectScenes_Msg._getAdsorbArr()
      for(let i in this.lensPart) {
        if(i === this.lensIndex) continue;
        this.adsorbArr = this.adsorbArr.concat(this._getAdsorbData(this.lensPart[i].matrix))
      }
    },
    showNetLine(arr) {
      // 显示元素变化时的辅助线
      arr.forEach((val, i) => {
        if(val.v) {
          if((i+2)%2 === 0) {
            this.netLine[i].show = true;
            this.netLine[i].top = val.v;
          } else {
            this.netLine[i].show = true;
            this.netLine[i].left = val.v;
          }
        }else {
          this.netLine[i].show = false;
        }
      })
    },
    toVertical() {
      // 竖版镜头数据处理
      this.lensPart.forEach((v,i) => {
        this.lensPart[i].matrix.w = v.matrix.h * 9 / 16;
        this.lensPart[i].matrix.x = v.matrix.x + v.matrix.h * 175 / 288;
      })
    },
    toHorizontal(m) {
      // 竖版镜头使用的还是横版的数据,所以这里是数据恢复成横版
      let m1 = Object.assign({}, m)
      if(this.TOOL.optimized === 'Vertical') {
        m1.w = m.h * 16 / 9;
        m1.x = m.x - m.h * 175 / 288;
      }
      return m1
    }
  }
}
</script>
<style lang="scss" scoped>
.set-camera {
  position: absolute;
  z-index: 150;
}
.camera {
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  border: 1px solid #fff;
  opacity: .4;

  &::before {
  position: absolute;
  display: block;
  content: '';
  border: 1px dashed #474261;
  height: 100%;
  width: 100%;
  margin: -1px;
  box-sizing: content-box;
  pointer-events: none;
  }
}
.camera-name {
  color: #fff;
  font-size: 13px;
  float: right;
  padding: 2px 10px;
  background-color: rgba(0,0,0,.2);
}
.camera-help {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  &:not(.active) {
    >div {
      display: none;
    }
  }
}
.camera.active {
  opacity: 1;
  z-index: 500;

  .camera-name {
    background-color: rgba(0,0,255,.2);
  }

  &::before {
    border: 1px dashed #1338CE;
  }
}
.camera_auxiliary {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  div {
    position: absolute;
    opacity: .6;

    &::before {
      position: absolute;
      display: block;
      content: '';
      box-sizing: content-box;
      pointer-events: none;
    }
  }

  div:nth-child(even) {
    height: 100%;
    width: 1px;
    border-left: 1px solid #fff;

    &::before {
      
      border-left: 1px dashed #00ffff;
      height: 100%;
      width: 1px;
      left: -1px;
      
    }
  }
  div:nth-child(odd) {
    width: 100%;
    height: 1px;
    border-top: 1px solid #fff;

    &::before {
      border-top: 1px dashed #00ffff;
      height: 1px;
      width: 100%;
      top: -1px;
    }
  }
}
.op-handle-point {
  background-color: #5778fb;
}
.camera-icon {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: -1;

  > div {
    width: 30px;
    height: 30px;
    position: absolute;
    overflow: hidden;

    &::before {
      content: '';
      width:35px;
      height: 35px;
      position: absolute;
      border: 2px solid #CDCCDC;
    }
  }

  .c-l-t {
    top: -10px;
    left: -10px;
    &::before {
      left: 0;
      top: 0;
    }
  }

  .c-r-t {
    top: -10px;
    right: -10px;
    &::before {
      right: 0;
      top: 0;
    }
  }

  .c-r-b {
    bottom: -10px;
    right: -10px;
    &::before {
      bottom: 0;
      right: 0;
    }
  }

  .c-l-b {
    bottom: -10px;
    left: -10px;
    &::before {
      bottom: 0;
      left: 0;
    }
  }
}

.op-handle-sw {
  cursor: sw-resize;
}
.op-handle-nw {
  cursor: nw-resize;
}
.op-handle-ne {
  cursor: ne-resize;
}
.op-handle-se {
  cursor: se-resize;
}
</style>



// WEBPACK FOOTER //
// src/components/tool/setCamera.vue